import { fieldId } from '../../field-id.model';

export class SortModel {
  constructor(
    public order: 'ASC' | 'DESC' | 'NONE' = 'NONE',
    public sort_by: 'SERIES' | 'DIMENSION' | 'BREAKDOWN' = 'SERIES',
    public sortByField = true, // otherwise sort by stack name
    public fieldSortKey: fieldId | number | null = null,
    public stackNameSortKey: number | null = null,
  ) {}
}
